import { ROTARACT_ADVISOR_ROLEID } from '@domain/clubs';

export const isRotaractAdvisor = (roleId: string) =>
  roleId === ROTARACT_ADVISOR_ROLEID;
